import { useState } from "react";
import { useApi } from "../helpers/useApi";
import { API_URL_ENDPOINT } from "../appsetting";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faFile, faFolder, faFolderOpen, faFilePdf, faFileWord, faFileExcel, faFilePowerpoint, faFileArchive, faFileAudio, faFileVideo, faFileAlt, faFileImage, faCheck, faCross, faCancel, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

export const TreeNode = ({ node, onExpand }) => {
  const api = useApi();
  const [expanded, setExpanded] = useState(false);
  const [children, setChildren] = useState([]);

  const toggleExpand = async () => {
    if (!expanded && !children.length) {
      const response = await api(API_URL_ENDPOINT.Files + `?path=${node.path}`);
      if (response.status) {
        setChildren(response.data);
      }
    }
    setExpanded(!expanded);
    onExpand?.(node);
  };



    const getFileIcon = (ext) => {
        const extLower = (ext || "").toLowerCase().replace(/^\./, "");

        if (["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"].includes(extLower)) return <FontAwesomeIcon icon={faFileImage} />;
        if (["pdf"].includes(extLower)) return <FontAwesomeIcon className="text-danger" icon={faFilePdf} />;
        if (["doc", "docx"].includes(extLower)) return <FontAwesomeIcon icon={faFileWord} />;
        if (["xls", "xlsx", "csv"].includes(extLower)) return <FontAwesomeIcon icon={faFileExcel} />;
        if (["ppt", "pptx"].includes(extLower)) return <FontAwesomeIcon icon={faFilePowerpoint} />;
        if (["zip", "rar", "7z"].includes(extLower)) return <FontAwesomeIcon icon={faFileArchive} />;
        if (["mp3", "wav"].includes(extLower)) return <FontAwesomeIcon icon={faFileAudio} />;
        if (["mp4", "avi", "mkv", "mov"].includes(extLower)) return <FontAwesomeIcon icon={faFileVideo} />;
        if (["txt", "log"].includes(extLower)) return <FontAwesomeIcon icon={faFileAlt} />;
        
        return <FontAwesomeIcon icon={faFolder} />;
    };

    if (node.isFile) {
    return (
      <li style={{ listStyleType: "none", marginLeft: "20px", userSelect:'none' }}>
        {getFileIcon(node.extention)}{" "}
        <a href={`${node.path}`} target="_blank" rel="noopener noreferrer">
          {node.name} | {node.fileSize ?? 0} KB | {node?.isSyncWithDB ? <FontAwesomeIcon className="text-success" icon={faCheckCircle}/> : <FontAwesomeIcon className="text-danger" icon={faCancel}/>}
        </a>
      </li>
    );
  }

  return (
    <li style={{ listStyleType: "none", userSelect:'none' }}>
      <div onClick={toggleExpand} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        <FontAwesomeIcon
        style={{fontSize:10}}
          icon={expanded ? faMinus : faPlus}
          className="me-2 text-primary border p-1"
        />
        <FontAwesomeIcon
          icon={expanded ? faFolderOpen : faFolder}
          className="me-2 text-warning"
        />
        <span>{node.name}</span>
      </div>
      {expanded && (
        <ul style={{ listStyleType: "none", paddingLeft: "20px" }}>
          {children.map(child => (
            <TreeNode key={child.path} node={child} onExpand={onExpand} />
          ))}
        </ul>
      )}
    </li>
  );
};
